import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DirectSaleProgramCreateRequest, DirectSaleProgram, DirectSaleImporterFilter, ProgramYearInformation, CreateMassiveProgramRequest, DirectSaleImporterRequest, CreateProgramFromStockRequest, ProgramsStatistics } from "src/app/domain/models/DirectSaleProgram";
import { Routes } from "src/app/infrastructure/routes";
import { DirectSaleProgramGateway } from "../gateway/DirectSaleProgramGateway";
import { ExportCloseSaleRequest, ExportOfferInformation } from "src/app/domain/models/ExportOffer";
import { AllowResponse } from "src/app/ui/util/responses-util";
import { PageResult } from "src/app/domain/models/PageResult";
import { AssignPalletStockRequest } from "src/app/domain/models/PalletStock";
import { ProgramMassiveUpload } from "src/app/domain/models/ProgramMassiveImport";

@Injectable({providedIn: 'root'})
export class DirectSaleProgramService extends DirectSaleProgramGateway {

  constructor(private _http: HttpClient) {
    super()
  }

  createWithOrders(request: DirectSaleProgramCreateRequest): Observable<DirectSaleProgram> {
    return this._http.post<DirectSaleProgram>(Routes.directSaleProgramApi + '/Create', request)
  }

  desactive(guid: any): Observable<DirectSaleProgram> {
    return this._http.get<DirectSaleProgram>(Routes.directSaleProgramApi + '/DeactivateProgram', { params :{guid}})
  }
  getByGuid(directSaleProgramGuid: string): Observable<DirectSaleProgram> {
    return this._http.get<DirectSaleProgram>(Routes.directSaleProgramApi + '/GetDirectSaleProgramByDirectSaleById', { params :{directSaleProgramGuid}})
  }

  getDirectSaleImporter(): Observable<ExportOfferInformation[]> {

    return this._http.get<ExportOfferInformation[]>(Routes.directSaleProgramApi + '/GetDirectSaleImporter')
  }

  getDirectSaleImporterFilter(request: DirectSaleImporterFilter): Observable<ExportOfferInformation[]>
  {
    return this._http.post<ExportOfferInformation[]>(
      Routes.directSaleProgramApi + '/GetDirectSaleImporterFilter',
      this.getFormDataCloseSaleForm(request)
    )
  }

  getDirectSaleImporterFilterPaged(request: DirectSaleImporterRequest): Observable<PageResult<ExportOfferInformation>>
  {
    return this._http.get<PageResult<ExportOfferInformation>>(
      Routes.directSaleProgramApi + '/GetDirectSaleImporterFilterPaged',
      {params: {...request}}
    )
  }

  editPalletStockWithProgram(palletStockIds: AssignPalletStockRequest,
    directSaleProgramGuid: string): Observable<any>
  {
    return this._http.put(Routes.directSaleProgramApi + '/EditPalletStockFromProgram', {orderGuid: null, palletStockIds, directSaleProgramGuid})
  }

  getFormDataCloseSaleForm(request: DirectSaleImporterFilter)
  {
    const formData = new FormData()
    if(request){

      if(request.speciesId){
        formData.append('speciesId', request.speciesId.toString())
      }
      if(request.exporterId){
          formData.append('importerId', request.exporterId.toString())
      }
      if(request.exportOfferId){
        formData.append('exportOfferId', request.exportOfferId.toString())
      }
      if(request.directSaleProgramId){
        formData.append('directSaleProgramId', request.directSaleProgramId.toString())
      }
      if(request.isActive == 0 || request.isActive == 1)
        {
      formData.append('isActive', request.isActive.toString())
      }
      if(request.kilosPerBox){
      formData.append('kilosPerBox', request.kilosPerBox)
      }
      if(request.harvestDate) {
        if(request.harvestDate instanceof Date)
          {
            request.harvestDate.toDateString()
            formData.append("harvestDate", new Date(request.harvestDate).toDateString())
          }

      }
      else {
        formData.append("harvestDate", '')
      }
      if(request.marketId){
      formData.append('marketId', request.marketId.toString())
      }
      if(request.speciesSize){
      formData.append('speciesSize', request.speciesSize.toString())
      }
      if(request.shelfLife){
      formData.append('shelfLife', request.shelfLife.toString())
      }
      if(request.price){
      formData.append('price', request.price.toString())
      }
      if(request.pageSize){
      formData.append('pageSize', request.pageSize.toString())
      }
      if(request.pageNumber){
      formData.append('pageNumber', request.pageNumber.toString())
      }
    }

    return formData
  }

  getRequestFile(request: any){
    const formData = new FormData();

    if(request) {
      if(request.file) formData.append("file", request.file)
      }
    return formData;
  }

  getRequestMassiveProgram(request: CreateMassiveProgramRequest){
    const formData = new FormData();

    if(request) {
      if(request.file) formData.append("file", request.file)
      if(request.file) formData.append("exporterUsername", request.exporterUsername)
    }
    return formData;
  }

  uploadOrdersProgram(request: any): Observable<any>{
    return this._http.post(
      Routes.directSaleProgramApi + '/UploadOrdersProgram',
      this.getRequestFile(request)
    )
  }

  getProgramYearInformation(year:number, directSaleProgramId: string): Observable<ProgramYearInformation> {
    return this._http.get<ProgramYearInformation>(Routes.directSaleProgramApi + '/GetProgramYearInformation', { params :{year, directSaleProgramId}})
  }

  deleteProgram(directSaleProgramGuid: any): Observable<any>{
    return this._http.delete(
      Routes.directSaleProgramApi + '/DeleteDirectSaleProgram', {params: {directSaleProgramGuid}}
    )
  }

  deleteProgramOrder(orderId: any): Observable<any>{
    return this._http.delete(
      Routes.directSaleProgramApi + '/DeleteDirectSaleProgramOrder', {params: {orderId}}
    )
  }

  validateDeleteProgram(directSaleProgramGuid: any): Observable<AllowResponse>{
    return this._http.get<AllowResponse>(
      Routes.directSaleProgramApi + '/ValidateDeleteProgram', {params: {directSaleProgramGuid}}
    )
  }

  validateDeleteProgramOrder(orderId: any): Observable<AllowResponse>{
    return this._http.get<AllowResponse>(
      Routes.directSaleProgramApi + '/ValidateDeleteProgramOrder', {params: {orderId}}
    )
  }

  uploadCreatePrograms(request: CreateMassiveProgramRequest): Observable<any>{
    return this._http.post(
      Routes.directSaleProgramApi + '/UploadPrograms', this.getRequestMassiveProgram(request)
    )
  }

  uploadUpdatePrograms(request: CreateMassiveProgramRequest): Observable<any>{
    return this._http.post(
      Routes.directSaleProgramApi + '/UpdatePrograms', this.getRequestMassiveProgram(request)
    )
  }

  downloadUserPrograms(username: string, startYear: number, endYear: number): Observable<any>{
    const headers = new HttpHeaders({
            'Content-Type':  'application/octet-stream'
          })
    return this._http.get(
      Routes.directSaleProgramApi + '/DownloadProgramsExcel', {params: {username, startYear, endYear}, headers: headers, observe: 'response', responseType: 'blob' as 'json'}
    )
  }

  downloadProgramsReport(username: string, startYear: number, endYear: number): Observable<any>{
    const headers = new HttpHeaders({
            'Content-Type':  'application/octet-stream'
          })
    return this._http.get(
      Routes.directSaleProgramApi + '/DownloadExporterProgramsExcel', {params: {username, startYear, endYear}, headers: headers, observe: 'response', responseType: 'blob' as 'json'}
    )
  }

  createProgramFromStock(request: CreateProgramFromStockRequest): Observable<any>{
    return this._http.post(
      Routes.directSaleProgramApi + '/CreateProgramFromStock', request
    )}

  getExporterProgramsStatistics(request: ExportCloseSaleRequest): Observable<ProgramsStatistics>{
    return this._http.get<ProgramsStatistics>(
      Routes.directSaleProgramApi + '/GetExporterDirectSaleProgramsStatistics',
      {params: {...request}}
    )
  }

  getProgramInformation(directSaleProgramId: string): Observable<ProgramYearInformation[]>{
    return this._http.get<ProgramYearInformation[]>(Routes.directSaleProgramApi + '/GetProgramInformation', { params :{ directSaleProgramId}})
  }

  getMassiveProgramsImport(pageNumber: number, pageSize: number): Observable<PageResult<ProgramMassiveUpload>>{
    return this._http.get<PageResult<ProgramMassiveUpload>>(Routes.directSaleProgramApi + '/GetProgramMassiveUploads', { params: { pageNumber, pageSize } })
  }

  downloadCompanyProgramsExcel(companyId: string, startYear: number, endYear: number): Observable<any>{
    const headers = new HttpHeaders({
            'Content-Type':  'application/octet-stream'
          })
    return this._http.get(
      Routes.directSaleProgramApi + '/DownloadProgramForwarderCompany', {params: {companyId, startYear, endYear}, headers: headers, observe: 'response', responseType: 'blob' as 'json'}
    )
  }
}
